import { Product } from 'src/utils/helpers/product';
import { productMatchesSelectedSmartTags } from 'src/utils/helpers/smart-tag-filtering';

export type UseFilterProductsQueryBySmartTagsParams = {
  smartTagsFromParams: string[];
  perPage: number;
  products: Product[];
  totalCount: number;
  totalPages: number;
};

function filterProductsBySmartTags(products: Product[], smartTagsFromParams: string[]): Product[] {
  return products.filter((product) => productMatchesSelectedSmartTags(product, smartTagsFromParams));
}

export function useFilterProductsQueryBySmartTags(
  params: UseFilterProductsQueryBySmartTagsParams
): Omit<UseFilterProductsQueryBySmartTagsParams, 'perPage' | 'smartTagsFromParams'> {
  const { products, totalCount, totalPages, perPage, smartTagsFromParams } = params;

  if (smartTagsFromParams.length) {
    const productsFilteredBySmartTags = filterProductsBySmartTags(products, smartTagsFromParams);
    const adjustedTotalPages = Math.ceil(productsFilteredBySmartTags.length / perPage);

    return {
      products: productsFilteredBySmartTags,
      totalCount: productsFilteredBySmartTags.length,
      totalPages: adjustedTotalPages,
    };
  }

  return {
    products,
    totalCount,
    totalPages,
  };
}
